import { ChevronLeft, ChevronRight, Check, Loader2 } from "lucide-react";

export default function NavigationButtons({
    currentStep,
    onPrevious,
    onNext,
    onSubmit,
    loading
}) {
    return (
        <div className="flex justify-between items-center mt-8 pt-6 border-t border-gray-200">
            <button
                type="button"
                onClick={onPrevious}
                disabled={currentStep === 1}
                className="flex items-center gap-2 px-6 py-2.5 border border-gray-300 rounded-lg text-xs font-medium hover:bg-gray-100 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
            >
                <ChevronLeft className="w-4 h-4" />
                Previous
            </button>

            {currentStep < 3 ? (
                <button
                    type="button"
                    onClick={onNext}
                    className="flex items-center gap-2 px-8 py-2.5 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-lg text-xs font-bold shadow-md hover:shadow-lg transition-all"
                >
                    Next
                    <ChevronRight className="w-4 h-4" />
                </button>
            ) : (
                <button
                    type="button"
                    onClick={onSubmit}
                    disabled={loading}
                    className="flex items-center gap-2 px-8 py-2.5 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-lg text-xs font-bold shadow-md hover:shadow-lg transition-all disabled:opacity-70"
                >
                    {loading ? (
                        <>
                            <Loader2 className="w-4 h-4 animate-spin" />
                            Creating...
                        </>
                    ) : (
                        <>
                            <Check className="w-4 h-4" />
                            Create Quote & Job
                        </>
                    )}
                </button>
            )}
        </div>
    );
}
